import {
  maxLength10,
  maxLength6,
  maxLength4,
  required,
  noDigits,
  number,
  trimError,
  onlyLettersAndHyphen,
  noHyphenStartOrEnd,
  onlyDigits,
  onlyLettersAndNumberAndHyphen,
  maxLength80,
  maxLength50,
  onlyLetters,
  trimNoSpecStartOrEnd,
  onlyHouse,
} from '../utils/validation';
import DTO from './DTO';

class WayBillDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'issue_created_at',
        type: String,
        validators: {},
        labelKey: 'issue_created_at',
      },
      {
        name: 'waybill_valid_from_date',
        type: String,
        validators: {},
        labelKey: 'issue_created_at',
      },
      {
        name: 'issue_created_at_to',
        type: String,
        validators: {},
        labelKey: 'issue_created_at_to',
      },
      {
        name: 'issue_created_at_from',
        type: String,
        validators: {},
        labelKey: 'issue_created_at_from',
      },
      {
        name: 'waybill_valid_from_date',
        type: String,
        validators: {},
        labelKey: 'issue_created_at',
      },
      {
        name: 'waybill_dispatched_at',
        type: String,
        validators: {},
        labelKey: 'issue_start',
      },
      {
        name: 'waybill_returned_at',
        type: String,
        validators: {},
        labelKey: 'issue_end',
      },
      {
        name: 'waybill_valid_from_date_to',
        type: String,
        validators: {},
        labelKey: 'issue_created_at_to',
      },
      {
        name: 'waybill_valid_from_date_from',
        type: String,
        validators: {},
        labelKey: 'issue_created_at_from',
      },
      {
        name: 'issue_start',
        type: String,
        validators: {},
        labelKey: 'issue_start',
      },
      {
        name: 'issue_start_to',
        type: String,
        validators: {},
        labelKey: 'issue_start_to',
      },
      {
        name: 'issue_start_from',
        type: String,
        validators: {},
        labelKey: 'issue_start_from',
      },
      {
        name: 'waybill_dispatched_at_to',
        type: String,
        validators: {},
        labelKey: 'issue_start_to',
      },
      {
        name: 'waybill_dispatched_at_from',
        type: String,
        validators: {},
        labelKey: 'issue_start_from',
      },
      {
        name: 'issue_end',
        type: String,
        validators: {},
        labelKey: 'issue_end',
      },
      {
        name: 'issue_end_to',
        type: String,
        validators: {},
        labelKey: 'issue_end_to',
      },
      {
        name: 'issue_end_from',
        type: String,
        validators: {},
        labelKey: 'issue_end_from',
      },
      {
        name: 'waybill_returned_at_to',
        type: String,
        validators: {},
        labelKey: 'issue_end_to',
      },
      {
        name: 'waybill_returned_at_from',
        type: String,
        validators: {},
        labelKey: 'issue_end_from',
      },
      {
        name: 'issue_valid_until',
        type: String,
        validators: {},
        labelKey: 'issue_valid_until',
      },
      {
        name: 'issue_valid_until_to',
        type: String,
        validators: {},
        labelKey: 'issue_valid_until_to',
      },
      {
        name: 'issue_valid_until_from',
        type: String,
        validators: {},
        labelKey: 'issue_valid_until_from',
      },
      {
        name: 'waybill_valid_until_date_to',
        type: String,
        validators: {},
        labelKey: 'issue_valid_until_to',
      },
      {
        name: 'waybill_valid_until_date',
        type: String,
        validators: {},
        labelKey: 'issue_valid_until',
      },
      {
        name: 'waybill_valid_until_date_from',
        type: String,
        validators: {},
        labelKey: 'issue_valid_until_from',
      },
      {
        name: 'vehicle_brand',
        type: String,
        validators: {},
        labelKey: 'vehicle_brand',
      },
      {
        name: 'carrier',
        type: String,
        validators: {},
        labelKey: 'carrier',
      },
      {
        name: 'grn_ts',
        type: String,
        validators: {},
        labelKey: 'grn_ts',
      },
      {
        name: 'vehicle_lpn',
        type: String,
        validators: {},
        labelKey: 'grn_ts',
      },
    ];
    super(attributes, params, isValidInit);
  }
}

export default WayBillDTO;
